import { CheckCircleOutlined } from '@ant-design/icons';
import { Button, Col, Input, message, PageHeader, Row, Spin, Timeline } from 'antd';
import { get, get_response } from 'helper/request';
import { Component } from 'react';
import { connect } from "react-redux";
import { objectiveType } from 'utils/const';
import { openEndPoint } from "../utils/utils";

const { TextArea } = Input;

export class ObjectiveCleaner extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            deviceId: this.props.match.params.id,
            viewingMode: 1,
            outputMessage: '',
            startStep: 0,
            currentStep: 0,
        }

        this.steps = ["Open door", "Stage is in Ejected position" ,"Check if Slide is removed", "All Done"];

    }

    goToSettings = (e) => {
	    openEndPoint("/scanner_settings/" + this.state.deviceId, false, true);
    }

    getTimelineItems = () => {
        let timelineItems = [];
        for (let i = this.state.startStep; i < this.state.currentStep + 1; i++) {
            timelineItems.push(this.getCurrentTimelineItem(i));
        }
        return timelineItems;
    }

    getCurrentTimelineItem = (index) => {
        if (index === 4 && this.state.currentStep === 4) {
            return (
                <Timeline.Item>
                    <Button type="primary" onClick={() =>this.changeObjective(objectiveType.FORTY_X)}>
                            Start Objective Cleaning 40X
                    </Button>
                    <br/><br/>
                    <Button type="primary" onClick={() =>this.changeObjective(objectiveType.HUNDRED_X)}>
                            Start Objective Cleaning 100X
                    </Button>
                </Timeline.Item>
            )
        }
        if (index === 1) {
            return (
                <Timeline.Item>
                    {this.steps[index]} &nbsp; &nbsp; &nbsp;
                    <Button type={this.state.currentStep === 1 ? "primary" : "secondary"} size="small" onClick={this.ejectSlide}>
                        Eject
                    </Button>
                </Timeline.Item>
            )
        }
        if (!(index === this.state.currentStep) || index === this.steps.length - 1) {
            return (
                <Timeline.Item dot={<CheckCircleOutlined style={{ fontSize: '16px' }} />} color="green">
                    {this.steps[index]}
                </Timeline.Item>
            );
        } else {
            if (index === 2){
                return (
                    <Timeline.Item>
                        {this.steps[index]} &nbsp; &nbsp; &nbsp;
                        <Button type="primary" size="small" onClick={() => this.changeViewingMode(2, 4)}>
                            Done
                        </Button>
                    </Timeline.Item>
                )
            }
            else {
                return (
                    <Timeline.Item>
                        {this.steps[index]} &nbsp; &nbsp; &nbsp;
                        <Button type="primary" size="small" onClick={() => this.updateStep(index + 1)}>
                            Done
                        </Button>
                    </Timeline.Item>
                )
            }
        }
    }

    ejectSlide = () => {
        this.updateStep(2);
        const url = "/server/devices/" + this.state.deviceId + "/eject/?background=false";
        get(url)
        .then(res => {
            message.success("Ejected successfully.")
        })
        .catch(err => {
            message.error("Eject Failed. Contact Admin");
        });
    }

    changeObjective = (objectiveType) => {

        this.setState({
            isFetching: true,
        })

        let url = "/server/devices/" + this.state.deviceId + "/manualmode/start-objective-cleaning/?objective="+ objectiveType
        get_response(url)
            .then(response => {
                let mess;
                if(response.status === 200){
                    mess = "Steps for cleaning"+'\n';
                    mess+= "1. Clean with Lint Free cotton/cloth or Microfiber lens cleaning cloth."+'\n'+"2. Dip it in IPA or Xylene."+'\n';
                    mess+= "3. Xylene is only recommended if the oil residual is solidified."
                    mess+= "4. Don't touch the needle while cleaning."
                    mess+= "4. Thank you!"
                    message.success("Objective Changed Successfully")
                }
                else{
                    mess = "Something went wrong. Contact Admin";
                    message.error(response.data)
                }
                this.setState({
                    isFetching: false,
                    outputMessage: mess,
                })
            })
            .catch(err => {
                console.log("Failed request", err);
                this.setState({
                    outputMessage: err.response.data,
                    isFetching: false,
                });
            });
    }

    updateStep = (step) => {
        this.setState({
            currentStep: step,
        });
    }

    getPageHeadingRow = (title) => {
        return (
            <Row>
                <Col span={20}>
                    <PageHeader style={{ backgroundColor: "#ffffff00", paddingBottom: "10px" }} title={title}></PageHeader>
                </Col>
                <Col span={4} style={{ padding: '16px 24px' }}>
                    <Button type="primary" onClick={this.goToSettings} ghost>
                        Back to Settings
                    </Button>
                </Col>
            </Row>
        )
    }

    getTimelineRow = () => {
        return (
            <Row>
                <Col offset={3} span={6}>
                    <Timeline>
                        {this.getTimelineItems()}
                    </Timeline>
                </Col>
                <Col span={5}>
                    <Row>
                        <b>Output Message</b>
                    </Row>
                    <br/>
                    <Row>
                        <TextArea
                            autosize={{ minRows: 8, maxRows: 6 }}
                            value={this.state.outputMessage}
                            style={{color: "black"}}
                            disabled
                        />
                    </Row>
                    <Row>
                    </Row>
                </Col>
            </Row>
        );
    }

    changeViewingMode = (mode, step) => {
        this.setState({
            viewingMode: mode,
            startStep: step,
            currentStep: step,
        })
    }

    render() {

        let viewer = undefined;

        if (this.state.viewingMode == 1) {
            viewer = (
                <Row>
                    {this.getPageHeadingRow("Objective Cleaning Process")}
                    <br/><br/>
                    <Col offset={2} span={3}>
                       <b>Steps to be followed</b>
                    </Col>
                    <br/><br/>
                    {this.getTimelineRow()}
                </Row>
            );
        } else if (this.state.viewingMode == 2) {
            viewer = (
                <Row>
                    {this.getPageHeadingRow("Start Objective Cleaning Process")}
                    <br />
                    {this.getTimelineRow()}
                </Row>
            );
        }

        return (
            <div>
                <Spin tip="Loading..." spinning={this.state.isFetching}>
                    {viewer}
                </Spin>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

export default connect(mapStateToProps)(ObjectiveCleaner);
